const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class ServiceService {
  // Obtener todos los servicios
  async getServices(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const response = await fetch(`${API_BASE_URL}/api/services?${queryParams}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los servicios');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getServices:', error);
      throw error;
    }
  }

  // Obtener servicios activos
  async getActiveServices() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/active`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los servicios activos');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getActiveServices:', error);
      throw error;
    }
  }

  // Obtener un servicio por ID
  async getServiceById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/${id}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener el servicio');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getServiceById:', error);
      throw error;
    }
  }

  // Crear nuevo servicio
  async createService(serviceData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(serviceData),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al crear el servicio');
      }
      
      return data;
    } catch (error) {
      console.error('Error en createService:', error);
      throw error;
    }
  }

  // Actualizar servicio
  async updateService(id, serviceData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(serviceData),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar el servicio');
      }
      
      return data;
    } catch (error) {
      console.error('Error en updateService:', error);
      throw error;
    }
  }

  // Eliminar servicio
  async deleteService(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/${id}`, {
        method: 'DELETE',
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar el servicio');
      }
      
      return data;
    } catch (error) {
      console.error('Error en deleteService:', error);
      throw error;
    }
  }

  // Obtener servicios eliminados
  async getDeletedServices(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const response = await fetch(`${API_BASE_URL}/api/services/deleted?${queryParams}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los servicios eliminados');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getDeletedServices:', error);
      throw error;
    }
  }

  // Eliminar servicio permanentemente
  async permanentDeleteService(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/${id}/permanent`, {
        method: 'DELETE',
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar el servicio permanentemente');
      }
      
      return data;
    } catch (error) {
      console.error('Error en permanentDeleteService:', error);
      throw error;
    }
  }

  // Restaurar servicio
  async restoreService(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/${id}/restore`, {
        method: 'PATCH',
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al restaurar el servicio');
      }
      
      return data;
    } catch (error) {
      console.error('Error en restoreService:', error);
      throw error;
    }
  }

  // Obtener servicios por categoría
  async getServicesByCategory(categoryId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/category/${categoryId}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los servicios por categoría');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getServicesByCategory:', error);
      throw error;
    }
  }

  // Obtener servicios por tipo de pago
  async getServicesByPaymentType(paymentType) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/payment-type/${paymentType}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los servicios por tipo de pago');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getServicesByPaymentType:', error);
      throw error;
    }
  }

  // Obtener estadísticas de servicios
  async getServiceStats() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/services/stats`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las estadísticas');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getServiceStats:', error);
      throw error;
    }
  }
}

export default new ServiceService();